<template>
  <div id="record-container">
    <div class="top-nav">
      <div class="button-box">
        <div class="back" @click="$router.back()">
          <i class="el-icon-arrow-left" style="margin-right: 3px" />
          <span>返回</span>
        </div>
        <span style="margin-right: 20px">{{ exam.examName }}</span>
        <span style="margin-right: 20px">{{ schoolName }}</span>
        <span>{{ exam.examCode }}</span>
      </div>
      <el-radio-group size="mini" fill="#d3e8ff" text-color="#409eff" v-model="pageType" @change="handlePageTypeChange">
        <el-radio-button label="切题" />
        <el-radio-button label="录题" />
      </el-radio-group>
      <div class="button-box">
        <el-button v-if="exam.paperUrl" size="medium" type="danger" plain @click="paperUploadError(exam)">试卷上传错误</el-button>
        <el-upload style="display:inline;margin: 0 10px;" action="" :http-request="uploadSectionFile" :show-file-list="false" accept=".doc, .docx, .pdf" :before-upload="beforeAction" :on-error="handleError">
          <el-button type="primary" plain size="medium">上传或更新试题卷</el-button>
        </el-upload>
        <el-button v-if="exam.paperUrl" plain size="medium" @click="_downPaper(exam.paperUrl)">下载试卷</el-button>
        <template v-else>
          <el-button plain size="medium" @click="showEditPaper = !showEditPaper">编辑试卷</el-button>
          <el-button plain size="medium" @click="save" :loading="submitLoading">保存录题</el-button>
        </template>

      </div>
    </div>

    <div class="record-container clearfix">
      <div class="content">
        <div class="left-section-title" style="margin-bottom: 20px;justify-content: space-between">
          <div class="left-section-title" style="margin-right: 20px">
            <span style="font-weight: 500;font-size: 16px;flex-shrink: 0">WORD试题卷</span>
            <img src="~images/warning.svg" alt="" width="20" height="20" style="margin: 0 10px">
            <span>根据上传试卷的格式：WORD还是PDF采用不同的录题方式，WORD采用框选题干信息等识别题目，PDF采用切割试卷区域进行题目匹配；</span>
          </div>
          <el-button v-if="exam.paperUrl" style="flex-shrink: 0" type="primary" size="mini" @click="handleToImg">
            <img src="~images/transform.png" width="14" height="14" style="margin-right: 3px;vertical-align: bottom">
            转化为图片
          </el-button>
        </div>
        <div class="paper" v-if="!showEditPaper" id="post-content" v-loading="loading" element-loading-text="加载中..." v-html="contentHtml" ref="tk_contain_upview" @mouseup="bindMouseUp" @mousedown="bindMouseDown"></div>
        <div class="paper" v-else>
          <vue-ckeditor types="document" v-model="contentHtml" v-loading="loading" :config="config1" />
        </div>
      </div>
      <div class="inner" ref="qieti" v-loading="loading">
        <h6>题号列表</h6>
        <div class="number addPaper-checkbox" v-if="toSeverArr.length > 0">
          <el-checkbox-group v-model="formQuestionIds">
            <el-checkbox :key="index" :label="item.standId" v-for="(item, index) in toSeverArr" disabled>
              <i v-if="item.bigNum">{{ item.bigNum }}.</i>
              {{ item.question }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-else class="number addPaper-checkbox no-data">
          <p>试题卷还未上传，上传试题卷</p>
        </div>
      </div>
    </div>

    <yue-dialog title="试题属性" :visible.sync="editQuesShow" width="1280px" center>
      <el-form class="form-wrapper" label-width="50px">
        <el-row>
          <el-col :span="14">
            <div class="operate">
              <el-form-item label="类型" id="tumuortigan">
                <el-radio-group v-model="quesRel">
                  <el-radio :label="1">题目</el-radio>
                  <el-radio :label="2">公共题干</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-show="quesRel == 1">
                <el-form-item label="题型" style="width: 550px;">
                  <el-radio-group v-model="question.pattern.id" v-if="isEdit">
                    <el-radio :key="index" :label="item.id" v-for="(item, index) in questionPatterns">{{ item.name
                      }}</el-radio>
                  </el-radio-group>
                  <el-radio-group v-model="question.pattern" v-else>
                    <el-radio :key="index" :label="item" v-for="(item, index) in questionPatterns">{{ item.name
                      }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="题干">
                  <div id="editor1">
                    <vue-ckeditor types="inline" v-model="question.content" :config="config" />
                  </div>
                </el-form-item>
                <el-form-item label="选项" v-if="question.pattern.type == 1">
                  <div id="editor1">
                    <div id="editor2" class="highLightFont" v-for="(itemm, index) in question.options" style="margin-left:10px">
                      <span v-if="index == 0">
                        <div class="optionTitle">A.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 1">
                        <div class="optionTitle">B.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 2">
                        <div class="optionTitle">C.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 3">
                        <div class="optionTitle">D.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 4">
                        <div class="optionTitle">E.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 5">
                        <div class="optionTitle">F.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                      <span v-if="index == 6">
                        <div class="optionTitle">G.</div>
                        <vue-ckeditor types="inline" v-model="question.options[index]" :config="config" />
                      </span>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="答案">
                  <el-radio-group v-model="question.answer" v-if="pattern.type == 1">
                    <el-radio label="A">A</el-radio>
                    <el-radio label="B">B</el-radio>
                    <el-radio label="C">C</el-radio>
                    <el-radio label="D">D</el-radio>
                    <el-radio label>暂无</el-radio>
                  </el-radio-group>
                  <div id="editor2" v-else>
                    <vue-ckeditor types="inline" v-model="question.answer" :config="config" />
                  </div>
                </el-form-item>
                <el-form-item label="解析">
                  <div id="editor2">
                    <vue-ckeditor types="inline" v-model="question.analysis" :config="config" />
                  </div>
                </el-form-item>
                <el-form-item label="知识点">
                  <el-tag size="small" v-for="(tag, index) in question.points" :key="index" closable :type="tag.type">{{
          tag.name }}</el-tag>
                </el-form-item>
              </div>
              <div class="question-title" v-show="quesRel == 2">
                <el-form-item label="题干">
                  <div style="display: inline-block;width: 300px;margin-top: 6px;">
                    <vue-ckeditor types="inline" v-model="topic.content" :config="config" />
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="question-ids">
              <div class="inner">
                <h6>题号列表</h6>
                <div class="number addPaper-checkbox">
                  <el-radio-group v-model="question.standId" v-if="quesRel == 1">
                    <el-radio :key="index" v-for="(item, index) in toSeverArr" :label="item.standId">
                      <i v-if="item.bigNum">{{ item.bigNum }}.</i>
                      {{ item.question }}
                    </el-radio>
                  </el-radio-group>
                  <el-checkbox-group v-model="topic.standIds" v-if="quesRel == 2">
                    <el-checkbox :key="index" :label="item.standId" v-for="(item, index) in toSeverArr">
                      <i v-if="item.bigNum">{{ item.bigNum }}.</i>
                      {{ item.question }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <ul>
                  <li v-for="item in allPicUrl" style="float: left;">
                    <img :src="item" style="max-height: 200px;max-width: 500px;" />
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <input type="text" class="input1" id="optionCount" style="height:0;width:0;border:none" />
        <el-button @click="editQuesShow = false">取 消</el-button>
        <el-button type="primary" @click="checkTopicInfo()" autofocus="autofocus">保 存</el-button>
      </span>
    </yue-dialog>
  </div>
</template>

<script>
import { updateSingleExam } from "@/api/exam/exam";
import { recordQuestionApi } from "@/v2/utils/api";
import { word2html, pdf2html } from '@/api/api'
import { insertQuestion, setPaperUploadError } from "@/api/recordQuestion";
import VueCkeditor from "vue-ckeditor2";
import { domain } from "@/config";
export default {
  components: { VueCkeditor },
  data () {
    return {
      pageType: '录题',
      submitLoading: false,
      config: {
        toolbar: [
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Subscript",
              "Superscript",
              "RemoveFormat",
            ],
          },
          {
            name: "justify",
            items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
            ],
          },
          {
            name: "insert",
            items: ["Nn", "SpecialChar", "Image", "Table", "Mathjax"],
          },
          { name: "undo", items: ["Undo", "Redo"] },
        ],
        mathJaxClass: "equation",
        filebrowserImageUploadUrl:
          domain + "/marking-platform/ossUpload/upload_to?CKEditorFuncNum=1",
        mathJaxLib:
          "//cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS-MML_HTMLorMML",
        extraPlugins:
          "clipboard,lineutils,widget,justify,dialog,mathjax,image,autogrow,nntag,imagebase",
        removeDialogTabs: "image:advanced;image:Link",
      },
      config1: {
        height: 400,
        mathJaxClass: "equation",
        filebrowserImageUploadUrl:
          domain + "/marking-platform/ossUpload/upload_to?CKEditorFuncNum=1",
        mathJaxLib:
          "//cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS-MML_HTMLorMML",
        extraPlugins:
          "clipboard,lineutils,widget,justify,dialog,mathjax,image,autogrow,nntag,imagebase,fixed",
        removeDialogTabs: "image:advanced;image:Link",
      },
      domain: domain,
      schoolId: "",
      schoolName: "",
      ossUrl: "",
      tags: [], //知识点
      allPicUrl: [],
      question: {
        rdnum: "",
        pattern: "", //题型
        analysis: "", //解析
        answer: "", //答案
        content: "", //题干
        oldContentHtml: "",
        options: [], //选项数组
        hardDegree: 0,
        points: [], //知识点
        score: 0,
        standId: "",
      },
      topic: {
        rdnum: "",
        content: "",
        oldContentHtml: "",
        standIds: [],
      },
      topicList: [],
      showEditPaper: false,
      loading: false,
      editQuesShow: false,
      currentEditQues: "",
      answerList: [],
      questionPatterns: "",
      isEdit: false,
      examId: this.$route.params.id,
      exam: "",
      contentHtml: "", //原始html
      questionIds: [],
      content: "", //鼠标选中html
      fragmentHtml: "", //拼装选中的html
      oldContentHtml: "", //选中的暂存html
      mouseUpPositionY: "",
      mouseUpPositionX: "",
      mouseDownPositionY: "",
      mouseDownPositionX: "",
      pattern: {},
      quesRel: 1,
      formQuestionTypeOne: "",
      formQuestionIds: [],
      toSeverArr: [], //本地缓存切题数据
      saveloading: false,
    };
  },
  mounted () {
    this.schoolId = this.$route.params.schoolId;
    this.schoolName = this.$route.query.schoolName;
    this.getPaper();
  },
  watch: {
    "question.pattern" (val) {
      if (val) {
        this.pattern = val;
        if (this.isEdit == true) {
          return;
        }
        if (val.type == 1) {
          this.question.oldContentHtml = this.question.content;
          this.question.content = this.question.content
            .replace(/<(?!(img|sup|sub|\/img|\/sup|\/sub)).*?>/g, "")
            .replace(/\r?\n/g, "");
          // let reg = "/(\d+\s*\..*?(?=A))([A-Z]\s*\..*?(?=[A-Z0-9]\s*\.|$))+/gs"//次正则可用于后续自动切题
          let newArr = this.question.content.split(/[A-Z]\s*[\.．、]/);
          let self = this;
          let Options = [];
          newArr.forEach((item, index) => {
            if (index == 0) {
              this.question.content = item;
            } else {
              Options.push(item);
            }
          });
          this.question.options = Options;
        } else {
          this.question.content = this.question.oldContentHtml;
        }
      }
    },
    "question.standId" (val) {
      this.allPicUrl = [];
      for (var j = 0; j < this.toSeverArr.length; j++) {
        if (val == this.toSeverArr[j].standId) {
          let positionArr = this.toSeverArr[j].position.split(";");
          positionArr.forEach((item) => {
            if (this.ossUrl.indexOf("myqcloud") > -1) {
              let list = [];
              item.split(",").map((t) => {
                list.push(t.split("_")[1]);
              });
              if (list.length == 5) {
                list.shift()
              }
              list = [list[2], list[3], list[0], list[1]]
              this.allPicUrl.push(
                this.ossUrl + "?imageMogr2/cut/" + list.join("x")
              );
            } else {
              this.allPicUrl.push(
                this.ossUrl + "?x-oss-process=image/crop," + item
              );
            }
          });
          this.question.answer = this.toSeverArr[j].answer;
          this.question.analysis = this.toSeverArr[j].analysis;
          this.question.points = this.toSeverArr[j].points;
        }
      }
    },
    "topic.standIds" (val) {
      this.allPicUrl = [];
      for (var i = 0; i < val.length; i++) {
        for (var j = 0; j < this.toSeverArr.length; j++) {
          if (val[i] == this.toSeverArr[j].standId) {
            let positionArr = this.toSeverArr[j].position.split(";");
            positionArr.forEach((item) => {
              if (this.ossUrl.indexOf("myqcloud") > -1) {
                let list = [];
                item.split(",").map((t) => {
                  list.push(t.split("_")[1]);
                });
                if (list.length == 5) {
                  list.shift()
                }
                list = [list[2], list[3], list[0], list[1]]

                this.allPicUrl.push(
                  this.ossUrl + "?imageMogr2/cut/" + list.join("x")
                );
              } else {
                this.allPicUrl.push(
                  this.ossUrl + "?x-oss-process=image/crop," + item
                );
              }
            });
          }
        }
      }
    },
  },
  methods: {
    handlePageTypeChange (page) {
      if (this.exam.isHen === 0) {
        this.$message.error('非有痕试卷不能切题！');
        this.pageType = '录题'
      }
      else if (page === '切题') {
        this.$router.push('/paper/split/' + this.$route.params.id + '/' + this.schoolId + '?importType=' + this.$route.query.importType + '&type=word' + '&schoolName=' + this.schoolName)
      }
    },
    async handleToImg () {
      let res = await recordQuestionApi.officeToImage({
        officeUrl: this.exam.paperUrl
      })
      if (res.success) {
        this.$router.push('/paper/record/pdf/' + this.$route.params.id + '/'
          + this.$route.params.schoolId + '?schoolName=' + this.schoolName + '&importType=' + this.$route.query.importType + '&from=word')
      } else {
        this.$message.error('转化失败！');
      }
    },
    async paperUploadError (exam) {
      let r = await this.$confirm(
        "点击确定将会在【试卷讲评】处提示老师重新上传试卷, 是否继续?",
        "提示",
        {
          type: "warning",
        }
      );

      let res = await setPaperUploadError({ examId: exam.id });

      if (res.success) {
        this.$message.success('试卷上传错误已通知老师');
      } else {
        this.$message.error(res.message);
      }
    },

    uploadSectionFile (params) {
      const file = params.file;
      if (file.size / 1024 / 1024 > 100) {
        this.$message({
          message: "文件大小不能超过100M",
          type: "warning"
        });
        return false;
      }
      const fileType = file.type;
      const form = new FormData();
      form.append("file", file);
      if (fileType.indexOf('pdf') > -1) {
        pdf2html(form).then(resp => {
          if (this.msg) {
            this.msg.close();
            this.msg = null;
          }
          const url = resp.body && resp.body.startsWith('http') ? resp.body : null;
          if (!url) {
            const message = resp.body || resp.message || '上传失败，请重试！';
            this.$message({ message, type: "error" });
            return;
          }
          let params = {
            id: this.examId,
            paperName: file.name,
            paperUrl: url,
            hasPaper: 1,
            schoolId: this.schoolId
          }
          this._updateSingleExam(params)
        }).catch(() => {
          this.$message.error('上传失败！');
        })
      } else {
        word2html(form).then(resp => {
          if (this.msg) {
            this.msg.close();
            this.msg = null;
          }
          const url = resp.body && resp.body.startsWith('http') ? resp.body : null;
          if (!url) {
            const message = resp.body || resp.message || '上传失败，请重试！';
            this.$message({ message, type: "error" });
            return;
          }
          let params = {
            schoolId: this.schoolId,
            id: this.examId,
            paperName: file.name,
            paperUrl: url,
            hasPaper: 1,
          };
          this._updateSingleExam(params);
        }).catch(() => {
          this.$message.error('上传失败！');
        });
      }
    },

    async _updateSingleExam (params) {
      let resp = await updateSingleExam(params);
      if (resp.success) {
        this.$message.success("上传成功")
      }
      let suffix = params.paperUrl.substring(params.paperUrl.lastIndexOf('.') + 1)
      if (suffix === 'pdf') {
        this.$router.push('/paper/record/pdf/' + this.examId + '/' + params.schoolId + '?schoolName=' + this.schoolName + '&importType=' + this.$route.query.importType)
      } else {
        setTimeout(() => {
          this.getPaper();
        }, 2000);
      }
    },
    handleError () { },
    beforeAction (file) {
      if (file.size / 1024 / 1024 > 30) {
        this.$message({
          message: '文件不能大于30M',
          type: 'warning'
        })
        return false
      }
      this.msg = this.$message({
        duration: 0,
        dangerouslyUseHTMLString: true,
        message: '<i class="el-icon-loading"></i>文件上传中，请勿关闭页面',
        type: "warning",
      });
    },
    // 下载试题
    _downPaper (url) {
      window.open(url, "_blank");
    },
    //组装数据传值到服务端
    async save () {
      try {
        this.$refs.tk_contain_upview.innerHTML;
      } catch (e) {
        this.$message({
          type: "warning",
          message: "数据错误",
        });
        return;
      }

      this.loading = true;
      this.submitLoading = true;
      let questions = {
        questions: this.toSeverArr,
        topics: this.topicList,
      };

      let params = {
        examName: this.exam.examName,
        schoolName: this.schoolName,
        examId: this.exam.id,
        questions: questions,
        content: this.$refs.tk_contain_upview.innerHTML,
      };

      try {
        let resp = await insertQuestion(params);

        setTimeout(() => {
          this.submitLoading = false;
        }, 1000);

        if (resp.code === 200) {
          this.loading = false;
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          this.loading = false;
          this.$message.error('保存失败，请重试')
        }
      } catch (err) {
        this.loading = false;
        this.$message.error('保存失败，请检查网络')
      }
    },
    async getPaper () {
      this.loading = true;
      let params = {
        examId: this.$route.params.id,
      };
      let self = this;
      let resp = await recordQuestionApi.queryExamQuestion(params);
      if (resp.success) {
        this.$nextTick(() => {
          if (resp.body.htmlContent) {
            this.contentHtml = this.replaceRevertAllHTML(
              resp.body.htmlContent
            );
          }
          this.questionPatterns = resp.body.questionPatterns;
          this.exam = resp.body.examBase;
          this.showEditPaper = this.exam.paperChange == 0 ? true : false;

          // 图片 http 换 https
          for (let item of resp.body.questions) {
            if (item.content) {
              item.content = item.content.replace(/src=\"http:/gi, "src=\"https:");
            }
            if (item.oldContentHtml) {
              item.oldContentHtml = item.oldContentHtml.replace(/src=\"http:/gi, "src=\"https:");
            }
          }

          this.toSeverArr = resp.body.questions;
          this.toSeverArr.forEach((item) => {
            if (item.rdnum) {
              this.formQuestionIds.push(item.standId);
            }
          });
          this.ossUrl = resp.body.examBase.standUrl;
          this.topicList = resp.body.topics;
          this.loading = false;
        });
      } else {
        this.loading = false;
        this.$message.error("查询失败，" + resp.message);
      }
    },

    // 判断a是否包含b
    isContained (a, b) {
      if (!(a instanceof Array) || !(b instanceof Array)) return false;
      if (a.length < b.length) return false;
      var aStr = a.toString();
      for (var i = 0, len = b.length; i < len; i++) {
        if (aStr.indexOf(b[i]) == -1) return false;
      }
      return true;
    },
    installHtml () {
      var range = this.range;
      var rdnum = this.isEdit
        ? this.question.rdnum.split("_")[1]
        : this.generateMixed(20);
      var sel_bg =
        '<div class="edit"></div>' + '<div class="del"></div>' + "</div>";
      this.quesRel == 1
        ? (sel_bg =
          "<div class='sel_bg' id='sel_bg_" +
          rdnum +
          "' unselectable='on' onselectstart='return false;' >" +
          sel_bg)
        : (sel_bg =
          "<div class='public_title sel_bg' unselectable='on' onselectstart='return false;'  id='sel_bg_" +
          rdnum +
          "'>" +
          sel_bg);
      let optionsHtml = "";
      let fragmentHtml = "";
      if (this.quesRel == 1) {
        if (this.question.pattern.type == 1) {
          this.question.options.forEach((item, index) => {
            if (index == 0) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">A.' + item + "</div>";
            } else if (index == 1) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">B.' + item + "</div>";
            } else if (index == 2) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">C.' + item + "</div>";
            } else if (index == 3) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">D.' + item + "</div>";
            } else if (index == 4) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">E.' + item + "</div>";
            } else if (index == 5) {
              optionsHtml =
                optionsHtml + '<div class="optionItem">F.' + item + "</div>";
            }
          });
          fragmentHtml =
            "<div class='question_list draw_a' id='topic_" +
            rdnum +
            "'>" +
            this.question.content +
            "<br>" +
            optionsHtml +
            sel_bg +
            "</div>";
        } else {
          fragmentHtml =
            "<div class='question_list draw_a' id='topic_" +
            rdnum +
            "'>" +
            this.question.content +
            sel_bg +
            "</div>";
        }
        if (!this.isEdit) {
          this.question.rdnum = "topic_" + rdnum;
        }
      } else {
        fragmentHtml =
          "<div class='question_list draw_a' id='topic_" +
          rdnum +
          "'>" +
          this.topic.content +
          sel_bg +
          "</div>";
        if (!this.isEdit) {
          this.topic.rdnum = "topic_" + rdnum;
        }
      }

      this.fragmentHtml = fragmentHtml;
      this.$nextTick(() => {
        var fragment = range.createContextualFragment(fragmentHtml);
        range.deleteContents();
        range.insertNode(fragment);
      });
    },
    // 确定切题
    checkTopicInfo (e) {
      if (this.quesRel != 2 && !this.question.pattern.name) {
        this.$message({
          message: "请选择题型",
          type: "warning",
        });
        return;
      }
      if (this.quesRel == 1 && !this.question.standId) {
        this.$message({
          message: "请选择对应题号",
          type: "warning",
        });
        return;
      }
      if (this.quesRel == 2 && this.topic.standIds.length == 0) {
        this.$message({
          message: "请选择对应题号",
          type: "warning",
        });
        return;
      }
      if (this.isEdit) {
        this.installHtml();
        this.cacheData(3);
      } else {
        if (this.question.content != "undefined") {
          let isInsatll = false;
          this.toSeverArr.forEach((item, index) => {
            if (item.standId == this.question.standId) {
              if (item.content) {
                isInsatll = true;
              }
            }
          });
          if (isInsatll) {
            this.$message({
              message: "所选题号已经录入过一题了",
              type: "warning",
            });
            return;
          } else {
            this.installHtml();
            this.cacheData(1);
          }
        } else {
          this.$message({
            message: "拉取失败，请重新尝试",
            type: "warning",
          });
        }
        document.getElementById("optionCount").select();
      }
    },
    /**
       * 缓存本地切题
       * @Author   fdd
       * @DateTime 2018-01-11
       * flag 1增 2删 3改
       * [{
        //     content: 题目内容,
        //     qType: 题目类型（1=客观题 2=主观题）,
        //     questionIds: 题目ID集合，多个中间以英文逗号隔开,
        //     examId: 考试ID
        // }]
       */
    cacheData (flag, rdnum) {
      let self = this;
      if (flag == 1) {
        if (this.quesRel == 1) {
          let indexTemp = -1;
          this.toSeverArr.forEach((item, index) => {
            if (item.standId == this.question.standId) {
              indexTemp = index;
              return;
            }
          });
          if (indexTemp != -1) {
            this.toSeverArr[indexTemp] = Object.assign(
              {},
              this.toSeverArr[indexTemp],
              this.question
            );
            this.formQuestionIds.push(this.question.standId);
          }
        } else {
          let indexTemp = -1;
          this.topicList.forEach((item, index) => {
            if (item.rdnum == this.topic.rdnum) {
              indexTemp = index;
              return;
            }
          });
          if (indexTemp != -1) {
            this.topicList[indexTemp] = Object.assign(
              {},
              this.topicList[indexTemp],
              this.topic
            );
          } else {
            this.topicList.push(this.topic);
          }
        }
      } else if (flag == 3) {
        if (this.quesRel == 1) {
          let indexTemp = -1;
          this.toSeverArr.forEach((item, index) => {
            if (item.rdnum == this.question.rdnum) {
              indexTemp = index;
              return;
            }
          });
          if (indexTemp != -1) {
            this.toSeverArr[indexTemp] = Object.assign(
              {},
              this.toSeverArr[indexTemp],
              this.question
            );
          }
        } else {
          let indexTemp = -1;
          this.topicList.forEach((item, index) => {
            if (item.rdnum == this.topic.rdnum) {
              indexTemp = index;
              return;
            }
          });
          if (indexTemp != -1) {
            this.topicList[indexTemp] = Object.assign(
              {},
              this.topicList[indexTemp],
              this.topic
            );
            this.editQuesShow = false;
          }
        }
      }
      this.editQuesShow = false;
    },
    // 绑定鼠标事件
    bindMouseUp (e) {
      this.mouseUpPositionY = e.pageY;
      this.mouseUpPositionX = e.pageX;
      if (
        this.mouseUpPositionX == this.mouseDownPositionX &&
        this.mouseUpPositionY == this.mouseUpPositionY
      ) {
        var target = e.target;
        var quesDiv;
        if (target.className == "edit") {
          quesDiv = e.target.parentNode.parentNode;
          this.toSeverArr.forEach((item) => {
            if (item.rdnum == quesDiv.id) {
              this.question = item;
              // this.question.content =this.question.oldContentHtml
              this.pattern = item.pattern;
              this.quesRel = 1;
              this.isEdit = true;
              this.editQuesShow = true;
              return;
            }
          });
          this.topicList.forEach((item) => {
            if (item.rdnum == quesDiv.id) {
              this.topic = item;
              this.quesRel = 2;
              this.isEdit = true;
              this.editQuesShow = true;
              return;
            }
          });
        }
        if (target.className == "del") {
          //定义函数
          Array.prototype.remove = function (val) {
            var index = this.indexOf(val);
            if (index > -1) {
              this.splice(index, 1);
            }
          };
          quesDiv = e.target.parentNode.parentNode;
          const _this = this;
          this.toSeverArr.forEach((item) => {
            if (item.rdnum == quesDiv.id) {
              var oP = _this.parseToDOM(item.oldContentHtml);
              document.getElementById(item.rdnum).previousSibling.append(oP);
              document.getElementById(item.rdnum).remove();
              this.formQuestionIds.remove(item.standId);
              item.rdnum = "";
              item.content = "";
              return;
            }
          });

          this.topicList.forEach((item) => {
            if (item.rdnum == quesDiv.id) {
              var oP = _this.parseToDOM(item.oldContentHtml);
              document.getElementById(item.rdnum).previousSibling.append(oP);
              document.getElementById(item.rdnum).remove();
              this.topicList.remove(item);
              return;
            }
          });
        }
        return;
      }
      this.getHtml(window);
      if (
        this.question.content.indexOf("data-v") >= 0 ||
        this.question.content == "undefined" ||
        this.question.content == ""
      ) {
        return;
      }
      this.isEdit = false;
      this.editQuesShow = true;
    },
    parseToDOM (str) {
      var div = document.createElement("div");
      if (typeof str == "string") div.innerHTML = str;
      return div;
    },
    bindMouseDown (e) {
      this.mouseDownPositionY = e.pageY;
      this.mouseDownPositionX = e.pageX;
    },
    // 替换所有html实体为html标签
    replaceRevertAllHTML (txt) {
      let value = txt;
      let leftCarr = /&lt;/g;
      let rightCarr = /&gt;/g;
      let dan = /&#39;/g;
      let and = /&amp;/g;
      let shuang = /&quot;/g;
      let du = /&ordm;/g;
      let jiao = /&ang;/g;
      let kongge = /&nbsp;/g;
      value = value.replace(leftCarr, "<");
      value = value.replace(rightCarr, ">");
      value = value.replace(shuang, '"');
      value = value.replace(dan, "'");
      value = value.replace(and, "&");
      value = value.replace(du, "º");
      value = value.replace(jiao, "∠");
      value = value.replace(kongge, " ");
      value = value.replace(/<br>/gi, "\n");
      value = value.replace(/<pre/g, "<div");
      value = value.replace(/<\/pre>/g, "</div>");
      value = value.replace(/(\s|&nbsp;)+/g, " "); // 将多个连续空格合并成一个空格
      value = value.replace(/((\s|&nbsp;)*\r?\n){3,}/g, "\r\n\r\n"); // 限制最多2次换行
      value = value.replace(/^((\s|&nbsp;)*\r?\n)+/g, ""); // 清除开头换行
      value = value.replace(/((\s|&nbsp;)*\r?\n)+$/g, ""); // 清除结尾换行
      value = value.replace(/\r?\n/g, "<br />"); // 回车转为br标签
      value = value.replace(/position: absolute;/g, "position: relative;");
      value = value.replace(/position:absolute;/g, "position: relative;");
      value = value.replace(
        /position:absolute;z-index:/g,
        "position:relative;"
      );
      value = value.replace(/z-index:2/g, "index:");
      value = value.replace(/text-indent/g, "text:");

      value = value.replace(/src=\"http:/gi, "src=\"https:");
      // 学科网图片只支持http
      value = value.replace(/src=\"https:\/\/static/gi, "src=\"http:\/\/static");
      return value;
    },
    /**
     * 随机数
     *
     * @param n
     * @returns {String}
     */
    generateMixed (n) {
      var chars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      var res = "";
      for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += chars[id];
      }
      return res;
    },
    //获取选中区域html
    getHtml (win) {
      var range = {};
      this.question = {
        rdnum: "",
        pattern: "", //题型
        analysis: "", //解析
        answer: "", //答案
        content: "", //题干
        oldContentHtml: "",
        options: [], //选项数组
        hardDegree: 0,
        points: [], //知识点
        score: 0,
        standId: "",
      };
      this.topic = {
        content: "",
        oldContentHtml: "",
        standIds: [],
      };
      if (win.getSelection) {
        //chrome,firefox,opera
        try {
          range = win.getSelection().getRangeAt(0);
          var container = win.document.createElement("div");
          container.appendChild(range.cloneContents());

          this.question.content = container.innerHTML;
          this.question.pattern = this.pattern;
          this.topic.content = container.innerHTML;
          this.topic.oldContentHtml = this.topic.content;
          this.question.oldContentHtml = this.question.content;
          this.range = range;
        } catch (e) { }
      } else if (win.document.getSelection) {
        try {
          range = win.document.getSelection().getRangeAt(0);
          var container = win.document.createElement("div");
          container.appendChild(range.cloneContents());
          this.question.content = container.innerHTML;
          this.question.pattern = this.pattern;
          this.topic.content = container.innerHTML;
          this.topic.oldContentHtml = this.topic.content;
          this.question.oldContentHtml = this.question.content;
          this.range = range;
        } catch (e) { }
      } else if (win.document.selection) {
        try {
          range = win.document.selection.createRange();
          var container = win.document.createElement("div");
          container.appendChild(range.cloneContents());
          this.question.content = container.innerHTML;
          this.question.pattern = this.pattern;
          this.topic.content = container.innerHTML;
          this.topic.oldContentHtml = this.topic.content;
          this.question.oldContentHtml = this.question.content;
          this.range = range;
        } catch (e) { }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  #editor1 {
    margin-top: 10px;
    display: inline-block;
  }

  #editor2 {
    margin-top: 10px;
    display: inline-block;
  }

  .inner {
    padding-left: 20px;
    width: 270px;
    background: #fff;

    .question-title {
      .el-textarea {
        display: inline-block;
      }
    }

    .number {
      margin-top: 6px;

      > p {
        line-height: 22px;
        font-size: 14px;
        font-weight: bold;
      }

      > ul {
        padding: 6px 0;

        > li {
          display: inline-block;
          margin: 4px 15px 10px 0;
          width: 38px;
          height: 26px;
          line-height: 24px;
          text-align: center;
          color: #447ed9;
          border: 1px solid #d6d6d6;
          border-radius: 3px;
          cursor: pointer;

          &:nth-child(5n) {
            margin-right: 0;
          }

          &:hover {
            background: #447ed9;
            color: #fff;
          }
        }
      }
    }
  }
}

.dialog-footer {
  .el-button {
    line-height: 0;
  }
}

.top-nav {
  width: 100%;
  height: 4.5vh;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #bbbbbb;
  padding: 0 20px;
  flex-shrink: 0;
  background-color: #447ed9;
  box-sizing: border-box;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  .back {
    display: flex;
    align-items: center;
    height: 22px;
    padding-right: 20px;
    border-right: 1px solid #bbbbbb;
    margin-right: 20px;
    cursor: pointer;
  }

  .pageTypeRadio {
    position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
  }

  .button-box {
    display: flex;
    align-items: center;
  }

  ::v-deep .el-radio-button span {
    color: #999999;
  }
}

.button-group {
  height: 70px;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    line-height: 0;
  }
}

.record-container {
  width: 100%;
  margin-bottom: 40px;
  background: #fff;
  margin-top: 4.5vh;
  padding: 20px;
  display: flex;
  align-items: center;

  .left-section-title {
    display: flex;
    align-items: center;
  }

  .content {
    width: 100%;
    margin-right: 320px;

    .paper {
      color: #333;
      line-height: 1.5;
      padding: 20px 29px;
      box-sizing: border-box;
      background-color: #f9f9f9;
      font-family: arial, SimSun, sans-serif, tahoma;
      overflow: hidden;
      width: 100%;
    }

    .tool {
      width: 220px;
    }
  }

  .inner {
    width: 300px;
    border: 1px solid #d6d6d6;
    background: #fff;
    position: fixed;
    right: 20px;
    top: 60px;

    > h6 {
      height: 36px;
      line-height: 36px;
      background: #447ed9;
      color: #fff;
      text-indent: 8px;
      font-size: 14px;
    }

    .number {
      padding: 10px 0 20px 20px;
      height: 80vh;
      overflow: auto;

      /*margin-top: 6px;*/
      > p {
        line-height: 22px;
        font-size: 14px;
        font-weight: bold;
      }

      > ul {
        padding: 6px 0;

        > li {
          display: inline-block;
          margin: 4px 15px 10px 0;
          width: 38px;
          height: 26px;
          line-height: 24px;
          text-align: center;
          color: #447ed9;
          border: 1px solid #d6d6d6;
          border-radius: 3px;
          cursor: pointer;

          &:nth-child(5n) {
            margin-right: 0;
          }

          &:hover {
            background: #447ed9;
            color: #fff;
          }
        }
      }
    }
  }
}

.el-dialog {
  .el-form-item {
    width: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }
}

.highLightFont {
  .optionTitle {
    float: left;
  }

  .ckeditor {
    margin-left: 30px;
  }
}

.record-header {
  flex: 1;
  display: flex;

  h4 {
    flex: 1;
    width: 0;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

::v-deep .el-checkbox__label {
  padding-top: 0px !important;
  line-height: 13px;
}

.cke.cke_reset_all {
  margin-top: -45px !important;
}

.cke_top.cke_reset_all {
  top: 0 !important;
}

.addPaper-checkbox .el-checkbox__label {
  font-size: 12px !important;
}

.operate .el-radio-group {
  line-height: 30px !important;
}

.addPaper-checkbox .el-radio__label {
  font-size: 12px;
  line-height: 35px;
}

.paper {
  img {
    height: unset !important;
    max-width: 100% !important;
  }
}

.el-button {
  height: 30px;
  font-size: 14px;
  border-radius: 4px;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: center;
  font-family: "Microsoft YaHei";
  padding: 0 20px;
}

* {
  box-sizing: border-box;
}

html,
body {
  background-color: white;
  height: 100%;
}
</style>

<style>
.addPaper-checkbox label {
  cursor: pointer;
  background: #ffffff;
  border: 0;
  border-radius: 3px;
  color: #447ed9;
  border: 1px solid #d6d6d6;
  margin-bottom: 5px;
  width: 38px;
  height: 38px;
  line-height: 26px;
  margin: 4px 12px 10px 0 !important;
}

.addPaper-checkbox label .el-checkbox__input {
  z-index: 0;
  color: #447ed9;
}

.addPaper-checkbox label .el-checkbox__label {
  position: absolute;
  z-index: 10;
  width: 38px;
  text-align: center;
  padding-left: 0;
  padding-top: 5px;
  color: #447ed9;
  white-space: pre-line;
}

.addPaper-checkbox label .el-checkbox__input.is-checked {
  height: 26px;
  margin-top: -5px;
}

.addPaper-checkbox label .el-checkbox__inner::after {
  display: none;
}

.addPaper-checkbox label .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #447ed9;
  border-color: #447ed9;
  color: #ffffff;
  width: 38px;
  height: 38px;
  position: absolute;
  z-index: 9;
  margin-top: 1px;
}

.addPaper-checkbox label .el-checkbox__inner {
  border-radius: 3px !important;
  background-color: inherit;
  border: 0;
  width: 0;
  height: 0;
}

.addPaper-checkbox label .el-radio__input {
  z-index: 0;
  color: #fff;
}

.addPaper-checkbox label .el-radio__label {
  position: absolute;
  z-index: 14;
  width: 38px;
  text-align: center;
  padding-left: 0;
}

.addPaper-checkbox label .el-radio__input.is-checked + .el-radio__label {
  color: #ffffff;
}

.addPaper-checkbox label .el-radio__input.is-checked {
  height: 26px;
}

.addPaper-checkbox label .el-radio__inner::after {
  display: none;
}

.addPaper-checkbox label .el-radio__input.is-checked .el-radio__inner {
  background-color: #447ed9;
  border-color: #447ed9;
  width: 38px;
  height: 38px;
  position: absolute;
  z-index: 9;
  margin: -3px 0 0 -1px;
}

.addPaper-checkbox label .el-radio__inner {
  background-color: inherit;
  border: 0;
  width: 0;
  height: 0;
  border-radius: 3px;
}

.addPaper-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ffffff;
}
</style>
